export const INSTANT_TRADE_DIALOG_DIMENSIONS = {
  width: 320,
  height: 410,
}
